
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class StudySystem extends Vue {
  tabList: Array<{
    key: string
    label: string
  }> = [
    {
      key: '1',
      label: '课堂的样子'
    },
    {
      key: '2',
      label: '在哪里上课'
    }
  ]

  currentTab: string = '1'

  change(key: string): void {
    if (!['1', '2'].includes(key) || this.currentTab === key) return

    this.currentTab = key
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
